import { builder } from '../../../common/js/config/index';

export const commonVideoConfig = {
  trackers: builder.holder({
    impression: builder.string('video_impression_trackers', {
      optional: true
    }),
    start: builder.string('video_start_trackers', {
      optional: true
    }),
    firstQuartile: builder.string('video_first_quartile_trackers', {
      optional: true
    }),
    midpoint: builder.string('video_midpoint_trackers', {
      optional: true
    }),
    thirdQuartile: builder.string('video_third_quartile_trackers', {
      optional: true
    }),
    complete: builder.string('video_complete_trackers', {
      optional: true
    })
  })
};
